import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : gndo wiki templates
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
import { TagMatcher } from 'uix/wiki/utils';
// ---Local imports
import { GndPopup } from './components';
// ---Exports
/* a Matcher for <Person/> <Place/> is already implemented in wiki/templates/vlext
also Markdown {person} {place}
*/ export const EntityPopup = TagMatcher('EntityPopup', ({ text, gnd, applyTemplates, childEls })=>{
    let trigger = /*#__PURE__*/ _jsx("div", {
        style: {
            display: 'inline'
        },
        children: applyTemplates()
    });
    return /*#__PURE__*/ _jsx(GndPopup, {
        gndid: gnd,
        trigger: trigger
    });
}, {}, 'Person / Corporate / Place / Subject');
